import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <ul className="footer-links">
            <li>
              <Link to="/RoomSuit">Rooms & Suites</Link>
            </li>
            <li>
              <Link to="/Dining">Dining</Link>
            </li>
            <li>
              <Link to="/leisure">Leisure</Link>
            </li>
            
            <li>
              <Link to="/cafekothi">Art Cafe</Link>
            </li>
            
            <li>
              <Link to="/Exclusivity&Events">Exclusivity & Events</Link>
            </li>
             <li>
             <Link to="/check-availability">
            Check Availability
          </Link>
        
            </li>
           
            <li>
              <Link to="/hotelpolicies">Hotel Policies</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
        
        <div className="footer-content">
          <ul className="footer-links policy-links">
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms-conditions">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/refund-policy">Refund Policy</Link>
            </li>
          </ul>
        </div>
        <div className="footer-content">
        <p className="footerKothi">
            <Link to ="/">&copy; 2024 TheArtKothi</Link>
            </p>
           
          <p className="footerMul">
            Created by{" "}
            <a
              href="https://www.multiplexersolution.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Multiplexer Solution Pvt Ltd
            </a>
            
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;